// extracted by mini-css-extract-plugin
module.exports = {"noBr":"Item-module--noBr--2oVJu","column":"Item-module--column--3kq-K","cell":"Item-module--cell--32NMI","label":"Item-module--label--18Ftk","text":"Item-module--text--2XguU"};